/* Education Cards collection-minimum cart enhancement. */
(() => {
  const selector = '[data-ec-cart-minimum]';
  let refreshTimer;

  const money = (cents) => `${new Intl.NumberFormat(document.documentElement.lang || 'uk-UA', {
    minimumFractionDigits: 0, maximumFractionDigits: 2,
  }).format(Math.max(0, cents) / 100)} грн`;

  function applyState(root, controlledSubtotal, controlledLineCount) {
    const minimum = Number(root.dataset.minimumCents || 0);
    const active = controlledLineCount > 0 && minimum > 0;
    const blocked = active && controlledSubtotal < minimum;
    const remaining = Math.max(0, minimum - controlledSubtotal);
    const progress = Math.min(100, minimum ? (controlledSubtotal / minimum) * 100 : 0);

    root.classList.toggle('is-inactive', !active);
    root.classList.toggle('is-blocked', blocked);
    root.classList.toggle('is-complete', active && !blocked);
    root.querySelector('[data-ec-minimum-progress]')?.replaceChildren(document.createTextNode(`${money(controlledSubtotal)} / ${money(minimum)}`));
    const message = root.querySelector('[data-ec-minimum-message]');
    if (message) {
      message.textContent = !active
        ? root.dataset.message
        : blocked
          ? `Додайте ще товарів на ${money(remaining)}`
          : 'Мінімальна сума гуртового замовлення виконана';
    }
    const bar = root.querySelector('[data-ec-minimum-bar]');
    if (bar) bar.style.width = `${progress}%`;

    document.querySelectorAll('[data-ec-minimum-checkout]').forEach((control) => {
      control.disabled = blocked;
      control.setAttribute('aria-disabled', String(blocked));
      control.closest('.cart__ctas, .cart-notification__links, .ec-cart-checkout')?.classList.toggle('ec-cart-checkout--blocked', blocked);
    });
    document.querySelectorAll('[data-ec-minimum-dynamic-checkout]').forEach((element) => {
      element.hidden = blocked;
    });
  }

  function stateFrom(container) {
    const lines = container.querySelectorAll('[data-ec-minimum-line]');
    let subtotal = 0;
    let count = 0;
    lines.forEach((line) => {
      if (line.dataset.ecMinimumControlled === 'true') {
        subtotal += Number(line.dataset.ecMinimumLineTotal || 0);
        count += 1;
      }
    });
    return { subtotal, count };
  }

  function updateFromDocument() {
    const roots = document.querySelectorAll(selector);
    if (!roots.length) return;
    const visibleCart = document.querySelector('cart-drawer.active') || document.querySelector('cart-items');
    if (visibleCart?.querySelector('[data-ec-minimum-line]')) {
      const state = stateFrom(visibleCart);
      roots.forEach((root) => applyState(root, state.subtotal, state.count));
    }
  }

  async function getServerState() {
    const roots = document.querySelectorAll(selector);
    if (!roots.length || !roots[0].dataset.minimumCents || Number(roots[0].dataset.minimumCents) <= 0) return null;
    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`, { credentials: 'same-origin' });
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      return stateFrom(parsed);
    } catch (error) {
      const visibleCart = document.querySelector('cart-drawer.active') || document.querySelector('cart-items');
      return visibleCart ? stateFrom(visibleCart) : null;
    }
  }

  async function refreshFromServer() {
    const state = await getServerState();
    if (state) document.querySelectorAll(selector).forEach((root) => applyState(root, state.subtotal, state.count));
    else updateFromDocument();
  }

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromServer, 80);
  }

  async function preventBlockedCheckout(event) {
    const checkout = event.submitter?.matches?.('[data-ec-minimum-checkout]')
      ? event.submitter
      : event.target.querySelector?.('[data-ec-minimum-checkout]');
    if (!checkout) return;
    if (event.target.dataset.ecMinimumValidated === 'true') {
      delete event.target.dataset.ecMinimumValidated;
      return;
    }
    event.preventDefault();
    const state = await getServerState();
    const root = document.querySelector(selector);
    if (!root || !state) return;
    applyState(root, state.subtotal, state.count);
    const blocked = state.count > 0 && state.subtotal < Number(root.dataset.minimumCents || 0);
    if (!blocked) {
      event.target.dataset.ecMinimumValidated = 'true';
      event.target.requestSubmit?.(checkout);
    }
  }

  document.addEventListener('submit', preventBlockedCheckout, true);
  document.addEventListener('DOMContentLoaded', () => {
    updateFromDocument();
    refresh();
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  });
  document.addEventListener('shopify:section:load', refresh);
  const cartDrawer = document.querySelector('cart-drawer');

if (cartDrawer) {
  const observer = new MutationObserver(() => {
    refresh();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}
})();
